import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/mspr/service-providers/')({
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/console/$orgId/mspr/service-providers/search', params, replace: true });
    },
});
